import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, matchPath, Link } from "react-router-dom";
import { Collapse } from "bootstrap/dist/js/bootstrap.bundle.min";

const NavBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const navbarRef = useRef(null);

  // Keep the search box in sync with the active route, so navigating
  // straight to a /search/:query URL (shared link, chatbot) shows the
  // query that's actually being searched.
  useEffect(() => {
    const match = matchPath("/search/:query", location.pathname);
    if (match?.params?.query) {
      setSearchTerm(decodeURIComponent(match.params.query));
    }
  }, [location.pathname]);

  // Close the responsive/mobile navbar using Bootstrap's collapse API.
  // Needed because client-side route changes (via <Link>) don't reload the
  // page the way the old plain <a> anchors did, which used to collapse the
  // menu for free.
  const closeNavbar = () => {
    const navbar = new Collapse(navbarRef.current, { toggle: false });
    navbar.hide();
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    closeNavbar();

    // Navigate to the search results page with the search query
    if (searchTerm.trim()) {
      navigate(`/search/${encodeURIComponent(searchTerm)}`);
    }
  };

  return (
    <nav className="navbar fixed-top navbar-expand-lg bg-body-tertiary">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/" onClick={closeNavbar}>
          <img
            src={"/assets/logos/cwh-logo-thin.png"}
            className="cwhLogo"
            alt="C.W. Hambleton"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
          ref={navbarRef}
        >
          <ul className="navbar-nav me-auto mb-2 mx-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/#featured" onClick={closeNavbar}>
                Featured
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#about" onClick={closeNavbar}>
                About
              </Link>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                rel="noreferrer"
                href="https://beingrefactored.com"
                target="_blank"
              >
                Blog
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#trailers" onClick={closeNavbar}>
                Trailers
              </Link>
            </li>
            <li className="nav-item dropdown">
              <button
                type="button"
                className="nav-link dropdown-toggle"
                style={{ background: "none", border: "none" }}
                id="navbarDropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Fiction
              </button>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <Link className="dropdown-item" to="/#fiction" onClick={closeNavbar}>
                  All Fiction Titles
                </Link>
                <div className="dropdown-divider"></div>
                <Link className="dropdown-item" to="/series/daysofnoah" onClick={closeNavbar}>
                  The Days of Noah Series
                </Link>
                <Link className="dropdown-item" to="/series/encounter" onClick={closeNavbar}>
                  The Encounter Series
                </Link>
                <Link className="dropdown-item" to="/series/hazikaron" onClick={closeNavbar}>
                  The HaZikaron Series
                </Link>
                <Link className="dropdown-item" to="/series/sonsofliberty" onClick={closeNavbar}>
                  The Sons of Liberty
                </Link>
                <Link
                  className="dropdown-item"
                  to="/series/timeofjacobstrouble"
                  onClick={closeNavbar}
                >
                  The Time of Jacob's Trouble
                </Link>
              </div>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#nonfiction" onClick={closeNavbar}>
                NonFiction
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#singles" onClick={closeNavbar}>
                Singles
              </Link>
            </li>
          </ul>
          <form className="d-flex" role="search" onSubmit={handleSearchSubmit}>
            <input
              className="form-control me-2"
              name="q"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
            <button className="btn btn-outline-success" type="submit">
              Search
            </button>
          </form>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
